import React from "react";

const Header = () => {
    return (
        <header>
            <h1>Welcome to Academie Avenir !</h1>
        </header>
    )
}

export default Header;
